import { Helmet } from 'react-helmet-async'
import { Box, Container, Typography } from '@mui/material'
import { Construction } from '@mui/icons-material'

export default function MaintenancePage() {
  return (
    <>
      <Helmet>
        <title>503 - Scheduled Maintenance | Taylin Helpdesk</title>
        <meta name="description" content="Taylin Helpdesk is currently undergoing scheduled maintenance. We'll be back shortly." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(135deg, #4e54c8 0%, #8f94fb 100%)',
          color: 'white'
        }}
      >
        <Container maxWidth="md">
          <Box textAlign="center">
            <Construction
              sx={{
                fontSize: { xs: '5rem', md: '8rem' },
                mb: 3,
                opacity: 0.9
              }}
            />
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: '3rem', md: '4rem' },
                fontWeight: 900,
                mb: 2,
                textShadow: '0 4px 20px rgba(0,0,0,0.3)'
              }}
            >
              Scheduled Maintenance
            </Typography>
            <Typography
              variant="h5"
              sx={{
                mb: 2,
                fontWeight: 500,
                opacity: 0.95
              }}
            >
              We're making improvements
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                opacity: 0.9,
                fontSize: '1.1rem',
                maxWidth: '600px',
                mx: 'auto'
              }}
            >
              Taylin Helpdesk is currently undergoing scheduled maintenance to improve performance and add new features.
              We'll be back shortly. Thank you for your patience.
            </Typography>
            <Typography
              variant="body2"
              sx={{
                opacity: 0.8,
                fontSize: '0.95rem'
              }}
            >
              For urgent inquiries, please contact support@taylindigital.com
            </Typography>
          </Box>
        </Container>
      </Box>
    </>
  )
}
